import React from 'react';
import { ComingSoonData } from '@/api/coming-soon';
import ComingSoonListing from '../components/my-account/ComingSoonListing';

interface ComingSoonModuleProps {
  data: ComingSoonData;
  userId?: string;
  culture?: string;
}

const ComingSoonModule: React.FC<ComingSoonModuleProps> = (props) => {
  const moduleProps = (props as any).props || props;
  const data = {
    text: props.data?.text || 'Stay updated with upcoming reports and publications.',
    comingSoonByDates: props.data?.comingSoonByDates || moduleProps.comingSoonByDates || { comingSoonReports: [] },
    directorySubscriptions: props.data?.directorySubscriptions || moduleProps.directorySubscriptions || [],
  };

  return <ComingSoonListing data={data} userId={props.userId} culture={props.culture} />;
};

export default ComingSoonModule;
